module.exports = __webpack_public_path__ + "img/VsShimmer4.9d0305d6.jpg";